import React, { Component } from 'react';
// import Logo from "../img/Logo_MinProd.svg";
import argentinaGob from '../img/argentinagob.png';

export default class Footer extends Component {
	render() {
		return (
			<footer className="main-footer">
				<div className="container">
					<div className="row">
						<div className="col-sm-6">
							<a href="https://www.produccion.gob.ar">
								<img className="image-responsive" src={argentinaGob} alt="Ministerio de Producción" />
							</a>
							<br />
							<p className="text-muted small">
								Los contenidos de Produccion.gob.ar están licenciados bajo&nbsp;
								<a href="https://creativecommons.org/licenses/by/2.5/ar/">
									Creative Commons Reconocimiento 2.5 Argentina License
								</a>
							</p>
						</div>
						<div className="col-md-3 col-sm-6">
							<div id="" className="">
								<div className="">
									<ul id="" className="">
										<li id="" className="">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://www.argentina.gob.ar/produccion"
											>
												El Ministerio
											</a>
										</li>
										<li id="" className="">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://www.argentina.gob.ar/produccion/datos-productivos"
											>
												Datos Productivos
											</a>
										</li>
										<li id="" className="">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://www.argentina.gob.ar/produccion/programasytramites"
											>
												Trámites
											</a>
										</li>
										<li id="" className="">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://www.argentina.gob.ar/anticorrupcion/obsequiosyviajes"
											>
												Registro de obsequios y viajes
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-md-3 col-sm-6">
							<div id="" className="">
								<div className="">
									<ul id="" className="">
										<li id="" className="">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://www.argentina.gob.ar/acerca"
											>
												Acerca de este sitio
											</a>
										</li>
										<li id="" className="">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://www.argentina.gob.ar/terminos-y-condiciones"
											>
												Términos y condiciones
											</a>
										</li>
										<li id="" className="">
											<a
												target="_blank"
												rel="noopener noreferrer"
												href="https://www.argentina.gob.ar/ayuda"
											>
												Ayuda
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="nav-footer">
					<div className="container">
						<div className="text-center">
							<p className="text-muted small">
								<strong>precios.produccion.gob.ar</strong> es un sitio web oficial del{' '}
								<strong>Gobierno Argentino</strong>
							</p>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}
